export default __webpack_public_path__ + "static/media/bg.6c2a7b53.webp";